// extracted by mini-css-extract-plugin
export default {"container":"Oca-z","tab":"Pca-z","selected":"Qca-z"};